import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';

import { DEMO_FEATURE_FLAGS, CustomerFeatureFlag } from '../models';
import { DemoStore } from '../stores';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  private readonly httpClient = inject(HttpClient);
  private readonly demoStore = inject(DemoStore);

  loadCustomerFeatureFlags(customerId?: number): Observable<CustomerFeatureFlag[]> {
    if (this.demoStore.isDemoMode()) {
      return of(DEMO_FEATURE_FLAGS);
    }

    return this.httpClient.get<CustomerFeatureFlag[]>(`/api/customers/${customerId ?? 'me'}/feature-flags`);
  }

  loadPartnerFeatureFlags(partnerId?: string): Observable<CustomerFeatureFlag[]> {
    if (this.demoStore.isDemoMode()) {
      return of(DEMO_FEATURE_FLAGS);
    }

    return this.httpClient.get<CustomerFeatureFlag[]>(`/api/partner/${partnerId ?? 'me'}/feature-flags`);
  }

  loadAdminFeatureFlags(): Observable<CustomerFeatureFlag[]> {
    if (this.demoStore.isDemoMode()) {
      return of(DEMO_FEATURE_FLAGS);
    }

    return this.httpClient.get<CustomerFeatureFlag[]>(`/api/admin/feature-flags`);
  }
}
